import { spawn } from 'redux-saga/effects';

import { sagas as listSagas } from './listModule';

export default function* zoneSagas() {
	yield spawn(listSagas);
}
